import { FAQLIST_UPDATES, FAQLIST_UPDATES_ERROR, FAQLIST_UPDATES_HIDE_ERROR, FAQLIST_UPDATES_START_LOADER, FAQLIST_UPDATES_STOP_LOADER } from "@frameworks/web/redux/interfaces/StaticFooter/iFaqList";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: undefined,
        isOpen: false,
    },
};
const FaqListReducer = (state = initState, action) => {
    switch (action.type) {
        case FAQLIST_UPDATES:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case FAQLIST_UPDATES_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case FAQLIST_UPDATES_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case FAQLIST_UPDATES_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case FAQLIST_UPDATES_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default FaqListReducer;
